import * as actionTypes from "./actionTypes";
import axiosRequest from "../../axios-request/request.methods";

//bi fetched
export const fetchPayments = (payload) => {
  return {
    type: actionTypes.FETCH_PAYMENT,
    formData: payload,
  };
};
// bi started
export const editPaymentsStarted = () => {
  // console.log(formData)
  return {
    type: actionTypes.FETCH_PAYMENT_START,
  };
};

export const editPaymentsSuccess = (formData, succMsg, res) => {
  return {
    type: actionTypes.FETCH_PAYMENT_SUCESS,
    formData: formData,
    succMsg: "Proposal Updated Successfully",
    response: res,
  };
};

export const editPaymentsFail = (errMsg) => {
  return {
    type: actionTypes.FETCH_PAYMENT_FAIL,
    error: errMsg,
  };
};
// export const fetchPaymentsSuccess = (payload, apiPath) => {
//   return async (dispatch) => {
//     dispatch(editPaymentsStarted());
//     try {
//       const result = await axiosRequest.put(apiPath, payload);
//       if (result?.length > 0) {
//         dispatch(editPaymentsSuccess(result));
//       } else {
//         dispatch(editPaymentsFail(result));
//       }

//       return result;
//     } catch (err) {
//       console.error("Error in fetchPaymentsSuccess:", err);
//       throw err; // Re-throw the error to propagate it to the caller
//     }
//   };
// };

export const fetchPaymentsSuccess = (payload, apiPath) => {
  return async (dispatch) => {
    dispatch(editPaymentsStarted());
    let result = await axiosRequest.put(apiPath, payload);
    console.log(result);
    if (result?.length > 0) {
      return dispatch(editPaymentsSuccess(result));
    } else {
      return dispatch(editPaymentsFail(result));
    }
  };
};
